var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 80.4998C41.1584 76.3699 36.6705 71.8423 32.5834 66.9643C26.4501 59.6388 19.1668 48.7291 19.1668 38.3331C19.1641 33.0238 20.7365 27.833 23.6851 23.4177C26.6336 19.0024 30.8257 15.561 35.7308 13.5291C40.636 11.4972 46.0336 10.9661 51.2407 12.0031C56.4478 13.04 61.2302 15.5983 64.9828 19.3543C67.4811 21.8416 69.4614 24.7997 70.809 28.0574C72.1566 31.3151 72.8446 34.8077 72.8334 38.3331C72.8334 48.7291 65.5501 59.6388 59.4168 66.9643C55.3297 71.8422 50.8418 76.3699 46.0001 80.4998ZM46.0001 26.8331C42.9501 26.8331 40.025 28.0447 37.8684 30.2014C35.7117 32.3581 34.5001 35.2831 34.5001 38.3331C34.5001 41.3831 35.7117 44.3082 37.8684 46.4649C40.025 48.6215 42.9501 49.8331 46.0001 49.8331C49.0501 49.8331 51.9751 48.6215 54.1318 46.4649C56.2885 44.3082 57.5001 41.3831 57.5001 38.3331C57.5001 35.2831 56.2885 32.3581 54.1318 30.2014C51.9751 28.0447 49.0501 26.8331 46.0001 26.8331Z",
    fill: "#02A7A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.31af22460bd1e4491c55aa809cbe9cb3.svg";
export { ForwardRef as ReactComponent };